import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'app/shared/shared.module';

import { InvestComponent } from './invest.component';
import { InvestSimulationComponent } from './invest-simulation/invest-simulation.component';
import { InvestProjectsComponent } from './invest-projects/invest-projects.component';
import { InvestEvalComponent } from './invest-eval/invest-eval.component';
import { ResultsComponent } from './invest-eval/sic-eval/results/results.component';
import { SimulationSelectComponent } from './simulation-select/simulation-select.component';
import { InvestInputComponent } from './invest-input/invest-input.component';
import { SicDatatableComponent } from './invest-simulation/sic-datatable/sic-datatable.component';
import { BbcDatatableComponent } from './invest-simulation/bbc-datatable/bbc-datatable.component';
import { SicProjectsComponent } from './invest-projects/sic-projects/sic-projects.component';
import { BbcProjectsComponent } from './invest-projects/bbc-projects/bbc-projects.component';
import { SicEvalComponent } from './invest-eval/sic-eval/sic-eval.component';
import { BbcEvalComponent } from './invest-eval/bbc-eval/bbc-eval.component';
import { LoaningComponent } from './invest-eval/sic-eval/loaning/loaning.component';
import { LoaningDatatableComponent } from './invest-eval/sic-eval/loaning/loaning-datatable/loaning-datatable.component';
import { CompareComponent } from './invest-eval/bbc-eval/compare/compare.component';
import { OverviewComponent } from './invest-eval/bbc-eval/overview/overview.component';
import { OverviewDatatableComponent } from './invest-eval/bbc-eval/overview/overview-datatable/overview-datatable.component';
import { InvestSelectComponent } from './invest-projects/invest-select/invest-select.component';
import { SaveInvestComponent } from './save-invest/save-invest.component';

@NgModule({
    declarations: [
        InvestComponent,
        InvestSimulationComponent,
        InvestProjectsComponent,
        InvestEvalComponent,
        ResultsComponent,
        LoaningComponent,
        LoaningDatatableComponent,
        SimulationSelectComponent,
        InvestInputComponent,
        SicDatatableComponent,
        BbcDatatableComponent,
        SicProjectsComponent,
        BbcProjectsComponent,
        SicEvalComponent,
        BbcEvalComponent,
        CompareComponent,
        OverviewComponent,
        OverviewDatatableComponent,
        InvestSelectComponent,
        SaveInvestComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        BbcDatatableComponent
    ],
    entryComponents: [
        SaveInvestComponent
    ]
})
export class InvestModule { }
